module.exports = __webpack_public_path__ + "static/UI pattern 2-d9487f845c37604ae23b47b95eb4148b.png";